import React from "react";
import { Box, Container, Typography} from "@mui/material";
import Reportdiagram from "../assets/Reportdiagram.png";
import Report from "../assets/Report.png";

export default function ReportsSection() {

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: "#fff" }}>
      <Container
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 6, md: 8 },
        }}
      >
        {/* === Left Image Section (Main Diagram) === */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={Reportdiagram}
            alt="Reports Diagram"
            sx={{
              width: { xs: "90%", sm: "85%", md: "100%" },
              borderRadius: 0,
              boxShadow: "none",
              objectFit: "contain",
            }}
          />
        </Box>

        {/* === Right Text Section === */}
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },
            maxWidth: 600,
          }}
        >
          <Typography
            variant="h4"
            fontWeight={800}
            mb={2}
            sx={{
              background: "linear-gradient(90deg, #1565c0, #004ba0)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Reports & Value Addition
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ lineHeight: 1.7, fontSize: "1.05rem", mb: 3 }}
          >
            Namami stretches to provide services with a <strong>professional approach</strong> to meet
            the expectations of its clients, adding measurable value to their property or business and
            improving asset value through detailed <strong>audit and analysis reports</strong>.
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ lineHeight: 1.7, mb: 3 }}
          >
            Namami maintains <strong>checks and balances</strong> through various processes and
            procedures including daily checklists, periodic reports, and management information systems (MIS)
            that provide a <strong>comprehensive daily, monthly, quarterly, and annual overview</strong> of
            operational efficiency.
          </Typography>

          {/* === Highlighted Box === */}
          <Box
            sx={{
              mt: 3,
              p: 2.5,
              background: "linear-gradient(135deg, #e3f2fd, #ffffff)",
              borderRadius: 2,
              borderLeft: "4px solid #1976d2",
            }}
          >
            <Typography variant="h6" fontWeight={700} color="primary" mb={1}>
              Value Addition
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              We go beyond operations — ensuring every report adds actionable insight, transparency, and
              accountability, driving continuous improvement across all facility management functions.
            </Typography>
          </Box>
        </Box>
      </Container>

      {/* === Bottom Image (Report Overview) === */}
      <Box
        sx={{
          mt: { xs: 8, md: 10 },
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={Report}
          alt="Report Overview"
          sx={{
            width: { xs: "80%", sm: "70%", md: "55%" },
            borderRadius: 0,
            boxShadow: "none",
            objectFit: "contain",
          }}
        />
      </Box>
    </Box>
  );
}
